module.exports = __webpack_public_path__ + "img/layout_bottom_3.faefbf9f.png";